export const INFUSION_MAPPING_CREATE = 'serviceData.INFUSION_MAPPING_CREATE';
export const INFUSION_MAPPING_DESTROY = 'serviceData.INFUSION_MAPPING_DESTROY';
export const INFUSION_MAPPINGS_DESTROY = 'serviceData.INFUSION_MAPPINGS_DESTROY';
export const INFUSION_MAPPING_ADD = 'serviceData.INFUSION_MAPPING_ADD';
export const INFUSION_MAPPING_ADD_COMMIT = 'serviceData.INFUSION_MAPPING_ADD_COMMIT';
export const INFUSION_MAPPING_REMOVE = 'serviceData.INFUSION_MAPPING_REMOVE';
export const INFUSION_MAPPING_REMOVE_COMMIT = 'serviceData.INFUSION_MAPPING_REMOVE_COMMIT';
